import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';

const ANNOUNCEMENTS = [
  {
    id: 2,
    title: 'URL Changed',
    summary: 'Login URL has been changed to idle.mnwalk.com',
    details: '**- URL Migration Notice**\n\nThe login URL has been changed from ssalsoongi.com to **idle.mnwalk.com**.\n\nPlease use [https://idle.mnwalk.com](https://idle.mnwalk.com) to log in from now on.\n\nAll features and data remain the same.',
    date: '05.03.2026',
  },
];

export default function AnnouncementModal({ open, onClose }) {
  const [selected, setSelected] = useState(null);

  if (!open) return null;

  const markdownComponents = {
    a: (props) => (
      <a href={props.href} target="_blank" rel="noreferrer">
        {props.children}
      </a>
    ),
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.25)',
        zIndex: 1400,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: 360,
          maxHeight: 520,
          background: '#E3FAFB',
          borderRadius: 18,
          boxShadow: '0 6px 18px 0 rgba(0,0,0,0.14)',
          padding: 18,
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          overflowY: 'auto',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 14,
            right: 18,
            background: 'transparent',
            border: 'none',
            fontSize: 24,
            cursor: 'pointer',
            color: '#349CA5',
          }}
        >
          ×
        </button>
        <div
          style={{
            fontWeight: 700,
            fontSize: 23,
            color: '#21B6B4',
            marginBottom: 22,
            textAlign: 'center',
            letterSpacing: 0.5,
          }}
        >
          • Announcements •
        </div>

        {selected === null ? (
          <div>
            {ANNOUNCEMENTS.map((notice) => (
              <div
                key={notice.id}
                onClick={() => setSelected(notice.id)}
                style={{
                  background: '#fff',
                  padding: '12px 16px',
                  borderRadius: 14,
                  marginBottom: 13,
                  cursor: 'pointer',
                  boxShadow: '0 1px 5px 0 rgba(36,210,219,0.08)',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 6,
                  }}
                >
                  <div
                    style={{
                      fontWeight: 600,
                      fontSize: 16,
                      color: '#349CA5',
                    }}
                  >
                    {notice.title}
                  </div>
                  <div
                    style={{
                      fontSize: 12,
                      color: '#B6B6B6',
                      marginLeft: 12,
                    }}
                  >
                    {notice.date}
                  </div>
                </div>
                <div
                  style={{
                    fontSize: 14,
                    color: '#505050',
                    opacity: 0.78,
                  }}
                >
                  {notice.summary}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div
            style={{
              background: '#fff',
              padding: '18px 16px 30px 16px',
              borderRadius: 14,
              marginBottom: 10,
              boxShadow: '0 1px 8px 0 rgba(36,210,219,0.10)',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 8,
              }}
            >
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 18,
                  color: '#26A5A8',
                }}
              >
                {ANNOUNCEMENTS.find((n) => n.id === selected)?.title}
              </div>
              <div
                style={{
                  fontSize: 12,
                  color: '#B6B6B6',
                  marginLeft: 12,
                }}
              >
                {ANNOUNCEMENTS.find((n) => n.id === selected)?.date}
              </div>
            </div>
            <div
              style={{
                fontSize: 15,
                color: '#303030',
                marginBottom: 26,
              }}
            >
              <ReactMarkdown components={markdownComponents}>
                {ANNOUNCEMENTS.find((n) => n.id === selected)?.details || ''}
              </ReactMarkdown>
            </div>
            <button
              onClick={() => setSelected(null)}
              style={{
                border: 'none',
                background: '#ABE5EA',
                color: '#349CA5',
                borderRadius: 8,
                padding: '7px 18px',
                fontWeight: 500,
                fontSize: 15,
                cursor: 'pointer',
                marginTop: 4,
              }}
            >
              Back to List
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
